module.exports = __webpack_public_path__ + "img/lasource-34.176d4488.jpg";